// extracted by mini-css-extract-plugin
module.exports = {"cookie":"CookiePolicy_cookie__ASYU4","content":"CookiePolicy_content__7IhoB"};